export enum PrintType {
    Unknown = 0,
    Online = 1,
    Offline = 2,
    Reprint = 3
}
